interface IApi {
  url: string;
  versionWithSettings: number;
  defaultApiVersion: number;
  defaultClientId: string;
  defaultPermission: number;
  moderatorPermission: number;
}

export const API: Readonly<IApi> = {
  url: window.vkTeams.config.baseUrl,
  versionWithSettings: 121,
  defaultApiVersion: 122,
  defaultClientId: "dmt0LW91dGxvb2stbWFjCg",
  defaultPermission: 32736,
  moderatorPermission: 32767,
};
